import { Route, Redirect, Switch } from 'react-router-dom';
import { useQuery } from 'utils/hooks/useQuery';
import MessageDispatch from '../components/MessageDispatch/messageDispatch';
import ApplicationRequest from '../pages/ApplicationRequest/AppRequest';
import BulkServiceAccountCreationTool from '../pages/BulkServiceAccountTool/BulkServiceAccountTool';
import ClinicalRecordingVidyo from '../pages/ClinicalRecordingVidyo/ClinicalRecordingVidyo';
import ComputerAdminRights from '../pages/ComputerAdminRights/ComputerAdminRights';
import Confirmation from '../pages/Confirmation/Confirmation';
import { Home } from '../pages/Home/Home';
import { LegacyPage } from 'pages/Legacy/LegacyPage';
import { RequestFlow } from '../pages/RequestFlow/RequestFlow';
import AddServiceAccount from '../pages/ServiceAccountFlow/Add/AddServiceAccount';
import ExistingServiceAccount from '../pages/ServiceAccountFlow/Existing/ExistingServiceAccount';
import ModifyServiceAccount from '../pages/ServiceAccountFlow/Modify/ModifyServiceAccount';
import UserAccessReview from '../pages/UserAccessReview/UserAccessReview';
import CMS from '../pages/CMS/CMS';
import { Utilities } from '../pages/Utilities/Utilities';
import LogViewerPage from '../pages/Support/IMSAdministration/LogViewer/LogViewerPage';
import WithOutageCheck from '../hoc/withOutageCheck/withOutageCheck';
import WorkQueueResults from '../pages/Support/WorkQueue/WorkQueue/WorkQueueResults';
import WorkQueueAdmin from '../pages/Support/WorkQueue/Admin/WorkQueueAdmin';
import RequestProcessing from '../pages/Support/WorkQueue/RequestProcessing/RequestProcessing';
import ApplicationInformation from '../pages/ApplicationInformation/ApplicationInformation';
import AppMaintenanceRouter from '../pages/ApplicationMaintenance/AppMaintenanceRouter';
import GlobalProtectException from '../pages/Admin/GlobalProtectExemption/GlobalProtectException';
import RoleDescriptions from '../pages/CMS/CMSDisplayComponents/RoleDescriptions/RoleDescriptions';
import ManagerValidation from 'pages/Bridges/ManagerValidation/ManagerValidation';
import { Startup } from 'pages/Legacy/Startup';
import IMSLDAPValidator from '../pages/IMSLDAPValidator/IMSLDAPValidator';
import EpicAdministrationRoutes from 'pages/Utilities/EpicAdministration/Routes';
import UserAccessReviewRoutes from '../pages/AnnualUserAccessReview/Routes';
import PendingApprovals from 'pages/PendingApprovals/PendingApprovals';
import NewNonEmployeeRoutes from 'pages/NewNonEmployee/NewNonEmployeeRoutes';
import AIException from 'pages/Admin/AIExemption/AIException';
import CitrixException from 'pages/Admin/CitrixException/CitrixException';
import SSHException from 'pages/Admin/SSHException/SSHException';
import ChallengeResponseValidation from 'pages/ChallengeResponseValidation/ChallengeResponseValidation';
import ChallengeResponseConfirmation from 'pages/ChallengeResponseValidation/ChallengeResponseConfirmation';

const LEGACY_CONFIRM_AND_DETAILS_ROUTES = [
	'/ConfirmSubmit.aspx',
	'/ConfirmAndProcessing.aspx',
	'/RRS/Submit_MultiUserRequests.aspx',
	'/RRS/Request_Detail_View.aspx',
	'/RRS/RequestDetails.aspx',
];

const Routes = () => {
	const searchParams = useQuery();

	let pageLegacy = '';
	if (searchParams.has('page')) {
		pageLegacy = decodeURIComponent(
			searchParams.toString().split('page=')[1].trim()
		);
	}
	let pageRedirect = '';
	if (searchParams.has('redirect')) {
		pageRedirect = decodeURIComponent(
			searchParams.toString().split('redirect=')[1].trim()
		);
	}

	return (
		<WithOutageCheck>
			<MessageDispatch />
			<Switch>
				<Route
					path={LEGACY_CONFIRM_AND_DETAILS_ROUTES}
					render={({ location }) => <LegacyPage path={location.pathname} />}
				/>
				<Route
					path='/BulkServiceAccountCreationTool'
					render={() => (
						<BulkServiceAccountCreationTool
							actionType='Add'
							requestType='Bulk'
						/>
					)}
				/>
				<Route
					path='/BulkServiceAccountCreationToolRevoke'
					render={() => (
						<BulkServiceAccountCreationTool
							actionType='Revoke'
							requestType='Bulk'
						/>
					)}
				/>
				<Route
					path='/AddServiceAccount'
					render={() => <AddServiceAccount />}
				/>
				<Route
					path='/ExistingServiceAccount'
					render={() => <ExistingServiceAccount />}
				/>
				<Route
					path='/ModifyServiceAccount'
					render={() => <ModifyServiceAccount />}
				/>
				<Route
					path='/Confirm/Index'
					render={() => <Confirmation />}
				/>
				<Route path='/Confirm' exact render={() => <Confirmation />} />
				<Route
					path='/RRS/Request_ModifyDetail_View.aspx'
					render={() => <ApplicationRequest />}
				/>
				<Route
					path='/OldUserAccessReview'
					render={() => <UserAccessReview />}
				/>
				<Route
					path='/ComputerAdminRights'
					render={() => <ComputerAdminRights />}
				/>
				<Route path='/RequestFlow' render={() => <RequestFlow />} />
				<Route
					path='/ClinicalRecordingVidyo'
					render={() => <ClinicalRecordingVidyo />}
				/>
				<Route
					path='/WorkQueue/WorkQueue'
					render={() => <WorkQueueResults />}
				/>
				<Route
					path='/WorkQueue/Admin'
					render={() => <WorkQueueAdmin />}
				/>
				<Route
					path='/WorkQueue/Request'
					render={() => (
						<RequestProcessing key={window.location.pathname} />
					)}
				/>
				<Route
					path='/WorkQueue/Request/:TrackingNumber'
					render={() => (
						<RequestProcessing key={window.location.pathname} />
					)}
				/>
				<Route
					path='/ChallengeResponseValidation/Confirmation'
					render={() => <ChallengeResponseConfirmation />}
				/>
				<Route
					path='/ChallengeResponseValidation'
					render={() => <ChallengeResponseValidation />}
				/>
				<Route
					path='/Admin/AIException'
					render={() => <AIException />}
				/>
				<Route
					path='/Admin/RemoteWorkerException'
					render={() => <CitrixException />}
				/>
				<Route
					path='/Admin/GlobalProtectException'
					render={() => <GlobalProtectException />}
				/>
				<Route
					path='/Admin/SSHException'
					render={() => <SSHException />}
				/>
				<Route path='/Utilities' render={() => <Utilities />} />
				<Route
					path={`/EpicUtilities`}
					render={() => <EpicAdministrationRoutes />}
				/>
				<Route
					path='/IMSAdministration'
					render={() => <LogViewerPage />}
				/>
				<Route path='/CMSManagement' render={() => <CMS />} />
				<Route
					path='/ApplicationInfo'
					render={() => <ApplicationInformation />}
				/>
				<Route
					path='/ApplicationMaintenance'
					render={() => <AppMaintenanceRouter />}
				/>
				<Route
					path='/AppRoleDescriptions'
					render={() => <RoleDescriptions />}
				/>
				<Route
					path='/Bridges/ManagerValidation'
					render={() => <ManagerValidation />}
				/>
				<Route
					path='/HelpDesk/IMSLDAPValidator'
					render={() => <IMSLDAPValidator />}
				/>
				<Route
					path='/PendingApprovals'
					render={() => <PendingApprovals />}
				/>
				<Route
					path='/UserAccessReview'
					render={() => <UserAccessReviewRoutes />}
				/>
				<Route
					path={`/NewNonEmployee`}
					render={() => <NewNonEmployeeRoutes />}
				/>
				<Route path='/startup.html' render={() => <Startup />} />
				<Route path='/index.html'>
					{pageLegacy ? (
						<LegacyPage path={pageLegacy} />
					) : pageRedirect ? (
						<Redirect to={pageRedirect} />
					) : (
						<Home />
					)}
				</Route>
				{!pageLegacy && !pageRedirect && <Route path='/'>404...</Route>}
			</Switch>
		</WithOutageCheck>
	);
};

export default Routes;
